import { createFileRoute, redirect } from '@tanstack/react-router';
import { OFAC_MATCH_BASE_PATH } from '../../../../../../../../features/watchlist/ofac/match/ofac-match-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/')({
  beforeLoad: () => {
    throw redirect({ to: OFAC_MATCH_BASE_PATH });
  },
  preload: false,
});
